import moment from 'moment';
import { format } from 'date-fns'
import { DateTime } from 'luxon';
// import {valueOrDefault} from '../../dist/helpers.js';
import { valueOrDefault } from 'chart.js/helpers';
import colorLib from '@kurkle/color';

var _seed = Date.now();

function timeDiff(timeFrom,timeTo) {
    // console.log(timeFrom)
    // console.log(timeTo)
    let mTimeFrom = moment(moment.utc(timeFrom).format('YYYY-MM-DD HH:mm:ss.SSS'))
    let mTimeTo = moment(moment.utc(timeTo).format('YYYY-MM-DD HH:mm:ss.SSS'))  
    return mTimeFrom.diff(mTimeTo,'days')
}

function fromNowDDiff(time) {
    let timeNow = moment.utc().format('YYYY-MM-DD HH:mm:ss.SSS');
    return timeDiff(time,timeNow)
}

function fromNowDDiffD(time) {
  let timeNow = moment.utc().format('YYYY-MM-DD 00:00:00.000')
  time = moment(moment.utc(time).format('YYYY-MM-DD 00:00:00.000'))  
  return timeDiff(time,timeNow)
}

function xHexToBytes (input) {
    if (typeof input !== 'string') {
      throw new TypeError('Expected input to be a string')
    }
  
    if ((input.length % 2) !== 0) {
      throw new RangeError('Expected string to be an even number of characters')
    }
  
    for (var bytes = [], c = 2; c < input.length; c += 2)
        bytes.push(parseInt(input.substring(c, c + 2), 16));
    return bytes;

  }

function bytesArrayToString (input) {
    const decoder = new TextDecoder('UTF-8')
    const array = new Uint8Array(input)
    return decoder.decode(array)
}

function xHexToString(input) {
    return bytesArrayToString(xHexToBytes(input))
    // xHexToBytes(input)
}

function formatedRTTime(reporttime) {
  let res = format(new Date(reporttime), 'HH:mm:ss')
  return res
}

function formatedRTDateTime(reportTime) {
  let resDate = '----.--.--'
  let resTime = '--:--:--'
  let diffTime = ''
  let timeNow = moment.utc().format('YYYY-MM-DD HH:mm:ss.SSS');
  
  try { 
    resDate = format(new Date(reportTime), 'yyyy-MM-dd')
    resTime = format(new Date(reportTime), 'HH:mm:ss')
    let mTimeFrom = moment(moment.utc(timeNow).format('YYYY-MM-DD HH:mm:ss.SSS'))
    let mTimeTo = moment(moment.utc(reportTime).format('YYYY-MM-DD HH:mm:ss.SSS'))  
    diffTime = mTimeFrom.diff(mTimeTo,'minutes')
  } catch (error) {    
    console.log(error)
  }
  return {date: resDate, time: resTime, diff: diffTime}
}


// dla Chart.js ################

function newDate(days) {
  return DateTime.now().plus({days}).toJSDate();
}

function newDateString(days) {
  return DateTime.now().plus({days}).toISO();
}

function rand(min, max) {
  min = valueOrDefault(min, 0);
  max = valueOrDefault(max, 0);
  _seed = (_seed * 9301 + 49297) % 233280;
  return min + (_seed / 233280) * (max - min);
}

function transparentize(value, opacity) {
  var alpha = opacity === undefined ? 0.5 : 1 - opacity;
  return colorLib(value).alpha(alpha).rgbString();
}

const CHART_COLORS = {
  red: 'rgb(255, 99, 132)',
  orange: 'rgb(255, 159, 64)',
  yellow: 'rgb(255, 205, 86)',
  green: 'rgb(75, 192, 192)',
  blue: 'rgb(54, 162, 235)',
  purple: 'rgb(153, 102, 255)',
  grey: 'rgb(201, 203, 207)',
  white: 'rgb(255, 255, 255)',
};

const NAMED_COLORS = [
  CHART_COLORS.red,
  CHART_COLORS.orange,
  CHART_COLORS.yellow,
  CHART_COLORS.green,
  CHART_COLORS.blue,
  CHART_COLORS.purple,
  CHART_COLORS.grey,
];

function namedColor(index) {
  return NAMED_COLORS[index % NAMED_COLORS.length];
}

const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

function months(config) {
  var cfg = config || {};
  var count = cfg.count || 12;
  var section = cfg.section;
  var values = [];
  var i, value;

  for (i = 0; i < count; ++i) {
    value = MONTHS[Math.ceil(i) % 12];
    values.push(value.substring(0, section));
  }

  return values;
}

function copyToClipboard(textToCopy) {
  // navigator clipboard api needs a secure context (https)
  if (navigator.clipboard && window.isSecureContext) {
      // navigator clipboard api method'
      return navigator.clipboard.writeText(textToCopy);
  } else {
      // text area method
      let textArea = document.createElement("textarea");
      textArea.value = textToCopy;
      // make the textarea out of viewport
      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      textArea.style.top = "-999999px";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      return new Promise((res, rej) => {
          // here the magic happens
          document.execCommand('copy') ? res() : rej();
          textArea.remove();
      });
  }
}

function fToC(f) {
  return ((f-32)*5/9).toFixed(1)
}

export {fromNowDDiff, fromNowDDiffD, timeDiff, xHexToString, formatedRTTime, formatedRTDateTime, 
        newDate, newDateString, rand, transparentize, CHART_COLORS, namedColor, months, copyToClipboard, fToC }

